import Image from 'next/image'
import contact from './WatchVideo.module.scss'
import Link from 'next/link'

export const WatchVideo = ({ title, description, image: { name: imgName, url: imgUrl }, video: { name: vidName, url: vidgUrl } }) => {
  return (
    <div className={contact.container}>
      <iframe
        width='100%'
        height='266'
        src={vidgUrl}
        title={vidName}
        frameBorder='0'
        allowFullScreen
        dasd
      />

      <Link href='/help_center/watch_videos/video'>
        <div className={contact.overlay}>
          <Image
            src={imgUrl}
            className={contact.logo1}
            alt={imgName}
            width={100}
            height={100}
          />
          <p className={contact.title}>{title}</p>
        </div>
        <div className={contact.description}>
          <p>{description}</p>
        </div>
      </Link>
    </div>

  )
}
